import api from './api';
import { pacienteMedicamentoService } from './pacienteMedicamentoService';
import { medicamentoRegistradoService } from './medicamentoRegistradoService';

export const authService = {
  login: async (nome, senha) => {
    const response = await api.post('/auth/login', { nome, senha });
    return response.data;
  },

  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  verifyToken: async () => {
    const response = await api.get('/auth/verify');
    return response.data;
  },

  definirSenhaLiberacao: async (senhaAtual, novaSenhaLiberacao) => {
    const response = await api.post('/auth/senha-liberacao', { 
      senhaAtual, 
      novaSenhaLiberacao 
    });
    return response.data;
  },

  verificarSenhaLiberacao: async () => {
    const response = await api.get('/auth/senha-liberacao/status');
    return response.data;
  }
};

export const medicamentoService = {
  getAll: async (params = {}) => {
    const response = await api.get('/medicamentos', { params });
    return response.data;
  },

  getGrupos: async (params = {}) => {
    const response = await api.get('/medicamentos/grupos', { params });
    return response.data;
  },

  getDetalhesGrupo: async (grupo) => {
    const response = await api.get('/medicamentos/grupos/detalhes', { params: grupo });
    return response.data;
  },

  getDetalhesGrupoPorId: async (id) => {
    const response = await api.get(`/medicamentos/${id}/grupo-detalhes`);
    return response.data;
  },

  buscarPorCodigoBarras: async (codigoBarras) => {
    const response = await api.get(`/medicamentos-registrados/codigo/${codigoBarras}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/medicamentos/${id}`);
    return response.data;
  },

  getByCodigoBarras: async (codigo) => {
    const response = await api.get(`/medicamentos/codigo-barras/${codigo}`);
    return response.data;
  },

  create: async (medicamento) => {
    const response = await api.post('/medicamentos', medicamento);
    return response.data;
  },

  update: async (id, medicamento) => {
    const response = await api.put(`/medicamentos/${id}`, medicamento);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/medicamentos/${id}`);
    return response.data;
  },

  getEstoqueBaixo: async () => {
    const response = await api.get('/medicamentos/alertas/estoque-baixo');
    return response.data;
  }
};

export const pacienteService = {
  getAll: async (params = {}) => {
    const response = await api.get('/pacientes', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/pacientes/${id}`);
    return response.data;
  },

  getByCpf: async (cpf) => {
    const response = await api.get(`/pacientes/cpf/${cpf}`);
    return response.data;
  },

  create: async (paciente) => {
    const response = await api.post('/pacientes', paciente);
    return response.data;
  },

  update: async (id, paciente) => {
    const response = await api.put(`/pacientes/${id}`, paciente);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/pacientes/${id}`);
    return response.data;
  }
};

export const liberacaoService = {
  getAll: async (params = {}) => {
    const response = await api.get('/liberacoes', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/liberacoes/${id}`);
    return response.data;
  },

  create: async (liberacao) => {
    const response = await api.post('/liberacoes', liberacao);
    return response.data;
  },

  confirmar: async (id, senha) => {
    const response = await api.post(`/liberacoes/${id}/confirmar`, { senha });
    return response.data;
  },

  autorizar: async (id) => {
    const response = await api.post(`/liberacoes/${id}/autorizar`);
    return response.data;
  },

  cancelar: async (id) => {
    const response = await api.put(`/liberacoes/${id}/cancelar`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/liberacoes/${id}`);
    return response.data;
  },

  getRelatorioResumo: async (params = {}) => {
    const response = await api.get('/liberacoes/relatorio/resumo', { params });
    return response.data;
  },

  // Buscar medicamentos vinculados disponíveis para liberação
  getMedicamentosVinculadosPaciente: async (pacienteId, params = {}) => {
    const response = await api.get(`/liberacoes/paciente/${pacienteId}/medicamentos-vinculados`, { params });
    return response.data;
  },

  // Buscar lotes disponíveis para um medicamento registrado
  getLotesMedicamento: async (medicamentoId) => {
    const response = await api.get(`/liberacoes/medicamento/${medicamentoId}/lotes`);
    return response.data;
  },

  // Buscar medicamentos disponíveis no estoque
  getMedicamentosEstoque: async (params = {}) => {
    const response = await api.get('/liberacoes/medicamentos-estoque', { params });
    return response.data;
  }
};

export const usuarioService = {
  getAll: async (params = {}) => {
    const response = await api.get('/usuarios', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/usuarios/${id}`);
    return response.data;
  },

  create: async (userData) => {
    const response = await api.post('/usuarios', userData);
    return response.data;
  },

  update: async (id, userData) => {
    const response = await api.put(`/usuarios/${id}`, userData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/usuarios/${id}`);
    return response.data;
  },

  toggleStatus: async (id, ativo) => {
    const response = await api.patch(`/usuarios/${id}/status`, { ativo });
    return response.data;
  },

  changePassword: async (id, senhaData) => {
    const response = await api.patch(`/usuarios/${id}/senha`, senhaData);
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/usuarios/stats');
    return response.data;
  }
};

export const visitanteService = {
  getMedicamentos: async (params = {}) => {
    const response = await api.get('/visitantes/medicamentos', { params });
    return response.data;
  }
};

export const notificacaoService = {
  getAll: async (params = {}) => {
    const response = await api.get('/notificacoes', { params });
    return response.data;
  },

  getCountNaoLidas: async () => {
    const response = await api.get('/notificacoes/count-nao-lidas');
    return response.data.count || 0;
  },

  marcarComoLida: async (id) => {
    const response = await api.patch(`/notificacoes/${id}/marcar-lida`);
    return response.data;
  },

  marcarTodasComoLidas: async () => {
    const response = await api.patch('/notificacoes/marcar-todas-lidas');
    return response.data;
  },

  apagarNotificacao: async (id) => {
    const response = await api.delete(`/notificacoes/${id}`);
    return response.data;
  },

  verificarAutomaticas: async () => {
    const response = await api.post('/notificacoes/verificar-automaticas');
    return response.data;
  }
};

// Exportar o serviço de pacientes-medicamentos
export const relatorioService = {
  getConsumoMedicamentos: async (dataInicio, dataFim) => {
    const response = await api.get('/relatorios/consumo-medicamentos', {
      params: { dataInicio, dataFim }
    });
    return response.data;
  },

  getPrevisaoMedicamentos: async () => {
    const response = await api.get('/relatorios/previsao-medicamentos');
    return response.data;
  },

  getMedicamentosMaisUtilizados: async (limite = 10, periodo = 30) => {
    const response = await api.get('/relatorios/medicamentos-mais-utilizados', {
      params: { limite, periodo }
    });
    return response.data;
  },

  teste: async () => {
    const response = await api.get('/relatorios/teste');
    return response.data;
  }
};

export { medicamentoRegistradoService };

export { pacienteMedicamentoService };